{
  "languageSettings": {
    "availableLanguages": [
      "en",
      "de",
      "it",
      "fr"
    ],
    "defaultLanguage": "de"
  },
  "UI": {
    "TITLE": "DispoSuite"
  },
  "enclosureSettings": {
    "minSlotWidth": 15,
    "minGapBetweenRails": 149
  },
  "urlSettings": {
    "PROJECT_MANAGEMENT": {
      "BASE": "project",
      "NAME_CHECK": "projectName",
      "GET_PROJECT_LIST": "list",
      "GET_PROJECT": "project"
    },
    "PRODUCT_CATALOG": {
      "BASE": "productcatalog",
      "GET_PRODUCT_CATALOG": ""
    },
    "ProductSelector": {
      "productSelectorListing": "http://localhost:7010/api/v1/ProductSelector",
      "productSelector": "http://localhost:7010/api/v1/ProductSelector/{psId}",
      "productImage": "https://kqbdyzc7mdyoue2scorzocyzyi0ktdrw.lambda-url.eu-west-3.on.aws/img_{reference}_jpg"
    }
  },
  "AssosciatedFileLimit": 5242880,
  "FileUploadThreshold": 79
}

